// ============================================
// Mapa de endpoints da API RAIZ (gestão em /api/raiz/*; era /api/management/raiz/* no Aura).
// Base same-origin ('') — o vite proxy (dev) e o nginx (prod) resolvem o destino.
// ============================================

export const API_ENDPOINTS = {
  RAIZ_DEVICES: '/api/raiz/devices',
  RAIZ_DEVICE: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}`,
  RAIZ_DEVICE_LOCATION: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/location`,
  RAIZ_DEVICE_CALIBRATIONS: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/calibrations`,
  RAIZ_DEVICE_SETPOINTS: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/setpoints`,
  RAIZ_DEVICE_HEATMAP: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/heatmap`,
  RAIZ_DEVICE_REPORT: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/report`,
  RAIZ_DEVICE_REPORT_ATTEST: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/report/attest`,
  RAIZ_DEVICE_REPORT_CSV: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/report.csv`,
  RAIZ_DEVICE_ATTESTATIONS: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/attestations`,
  RAIZ_DEVICE_MASTER_AUDIT: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/master/audit`,
  RAIZ_CLOCK_DRIFT: '/api/raiz/clock-drift',
  RAIZ_EXPORTS: '/api/raiz/exports',
  RAIZ_DEVICE_CONFIG_PUSH: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/config-push`,
  RAIZ_VERIFY: (id: string) => `/api/raiz/verify/${encodeURIComponent(id)}`,
  RAIZ_INGEST_HEALTH: '/api/raiz/ingest-health',
  RAIZ_DEVICE_KEYS: '/api/raiz/device-keys',
  RAIZ_DEVICE_KEY: (mac: string) => `/api/raiz/device-keys/${encodeURIComponent(mac)}`,
  // Credenciais por device (raiz_iot#47) — platform_admin
  RAIZ_CREDENTIALS_STATUS: '/api/raiz/credentials/status',
  RAIZ_FLEET_INSTALL_PASSWORD: '/api/raiz/fleet/install-password',
  RAIZ_DEVICE_CREDENTIALS: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/credentials`,
  RAIZ_DEVICE_CREDENTIALS_ROTATE: (mac: string) => `/api/raiz/devices/${encodeURIComponent(mac)}/credentials/rotate`,
  RAIZ_UNITS: '/api/raiz/units',
  RAIZ_UNITS_IMPORT: '/api/raiz/units/import',
  RAIZ_UNIT_BAND_HISTORY: (id: number) => `/api/raiz/units/${id}/band-history`,
  RAIZ_UNIT_LEVELS: (id: number) => `/api/raiz/units/${id}/levels`,
  RAIZ_SITES: '/api/raiz/sites',
  RAIZ_SITE: (id: number) => `/api/raiz/sites/${id}`,
  RAIZ_SITE_ACTIVE: (id: number) => `/api/raiz/sites/${id}/active`,
  RAIZ_UNIT: (id: number) => `/api/raiz/units/${id}`,
  RAIZ_UNIT_DEVICES: (id: number) => `/api/raiz/units/${id}/devices`,
  RAIZ_UNIT_DEVICE: (id: number, mac: string) => `/api/raiz/units/${id}/devices/${encodeURIComponent(mac)}`,
  RAIZ_UNIT_DEVICE_POSITION: (id: number, mac: string) => `/api/raiz/units/${id}/devices/${encodeURIComponent(mac)}/position`,
  RAIZ_UNIT_DEVICE_MONITORING: (id: number, mac: string) => `/api/raiz/units/${id}/devices/${encodeURIComponent(mac)}/monitoring`,
  RAIZ_ALARM_PROFILES: '/api/raiz/alarm-profiles',
  RAIZ_ALARM_PROFILE: (id: number) => `/api/raiz/alarm-profiles/${id}`,
  RAIZ_UNIT_ALARM_PROFILE: (id: number) => `/api/raiz/units/${id}/alarm-profile`,
  RAIZ_UNIT_FLOORPLAN: (id: number) => `/api/raiz/units/${id}/floorplan`,
  RAIZ_UNIT_REPORT: (id: number) => `/api/raiz/units/${id}/report`,
  RAIZ_UNIT_EXCURSIONS: (id: number) => `/api/raiz/units/${id}/excursions`,
  RAIZ_UNIT_EXCURSIONS_DETECT: (id: number) => `/api/raiz/units/${id}/excursions/detect`,
  RAIZ_EXCURSIONS: '/api/raiz/excursions',
  RAIZ_EXCURSIONS_SUMMARY: '/api/raiz/excursions/summary',
  RAIZ_EXCURSION: (eid: number) => `/api/raiz/excursions/${eid}`,
  RAIZ_EXCURSION_AUDIT: (eid: number) => `/api/raiz/excursions/${eid}/audit`,
  RAIZ_SETTINGS: '/api/raiz/settings',
  // ── FOTA v1 (Console de Frota — gestão de firmware) ─────────────────────────
  RAIZ_FIRMWARE_RELEASES: '/api/raiz/firmware/releases',
  RAIZ_FIRMWARE_RELEASE_ACTIVATE: (id: number) => `/api/raiz/firmware/releases/${id}/activate`,
  RAIZ_FIRMWARE_RELEASE_DEACTIVATE: (id: number) => `/api/raiz/firmware/releases/${id}/deactivate`,
  RAIZ_FIRMWARE_RELEASE_RESUME: (id: number) => `/api/raiz/firmware/releases/${id}/resume`,
  RAIZ_FIRMWARE_RELEASE_CANARY: (id: number) => `/api/raiz/firmware/releases/${id}/canary`,
  RAIZ_FIRMWARE_DEVICES: '/api/raiz/firmware/devices',
  // Lab de Bateria: frota (plataforma, ou ?scope=company) e curva por device.
  RAIZ_BATTERY_FLEET: '/api/raiz/battery/fleet',
  RAIZ_BATTERY_CURVE: (mac: string) => `/api/raiz/battery/devices/${encodeURIComponent(mac)}/curve`,
  RAIZ_FIRMWARE_DEVICE_RESUME: (mac: string) => `/api/raiz/firmware/devices/${encodeURIComponent(mac)}/resume`,
  RAIZ_FIRMWARE_AUDIT: '/api/raiz/firmware/audit',
  RAIZ_FIRMWARE_AUDIT_ANNOTATION: (id: number) => `/api/raiz/firmware/audit/${id}/annotation`,
  // Bancada (Cenário A — flash de fresh device por USB/WebSerial).
  RAIZ_FIRMWARE_RELEASE_FACTORY: (id: number) => `/api/raiz/firmware/releases/${id}/factory`,
  RAIZ_FIRMWARE_RELEASE_FACTORY_BIN: (id: number) => `/api/raiz/firmware/releases/${id}/factory.bin`,
  RAIZ_FIRMWARE_BENCH_FLASH: '/api/raiz/firmware/bench-flash',
  RAIZ_ALERT_CHANNELS: '/api/raiz/alert-channels',
  RAIZ_ALERT_CHANNEL: (id: number) => `/api/raiz/alert-channels/${id}`,
  RAIZ_ALERT_CHANNEL_TEST: (id: number) => `/api/raiz/alert-channels/${id}/test`,
  AUTH_ME: '/api/auth/me',
  AUTH_ME_PASSWORD: '/api/auth/me/password',
  AUTH_USERS: '/api/auth/users',
  AUTH_USER: (id: string) => `/api/auth/users/${encodeURIComponent(id)}`,
  AUTH_USER_LINK: '/api/auth/users/link',
  AUTH_USER_MEMBERSHIP: (id: string) => `/api/auth/users/${encodeURIComponent(id)}/membership`,
  AUTH_SWITCH_COMPANY: '/api/auth/switch-company',
  AUTH_API_KEYS: '/api/auth/api-keys',
  AUTH_API_KEY: (id: string) => `/api/auth/api-keys/${encodeURIComponent(id)}`,
  PLATFORM_COMPANIES: '/api/platform/companies',
  PLATFORM_COMPANY: (id: string) => `/api/platform/companies/${encodeURIComponent(id)}`,
  PLATFORM_BACKUP_STATUS: '/api/platform/backup-status',
  // Vigia do certificado TLS público (#151) — read-only, platform viewer.
  PLATFORM_TLS_STATUS: '/api/platform/tls-status',
  // Conexão do número de WhatsApp do RAIZ (provedor baileys) — só platform_admin.
  PLATFORM_WHATSAPP: '/api/platform/whatsapp',
  PLATFORM_WHATSAPP_PAIR: '/api/platform/whatsapp/pair',
  PLATFORM_WHATSAPP_LOGOUT: '/api/platform/whatsapp/logout',
  PLATFORM_DEVICE_TRANSFER: (mac: string) => `/api/platform/devices/${encodeURIComponent(mac)}/transfer`,
  PLATFORM_DEVICE_TRANSFERS: '/api/platform/device-transfers',
}
